import './brokerAlternativeFundsIntroVideo.scss';
import React, { useState } from 'react';
const { formatText, FormattedText } = require('core/i18n').i18n;


const BrokerAlternativeFundsIntroVideo = () => {
    const [startedVideo, setStartedVideo] = useState(false);
    const notStartedState = (
        <div className="broker-alternative-funds-intro-video__cover">
            <div
                onClick={() => setStartedVideo(true)}
                className="cover-container__playButton"
                tabIndex="9"
            >
                <div className="broker-alternative-funds-intro-video__play-circle">
                    <svg
                        width="37.3px"
                        height="40.6px"
                        viewBox="0 0 32 32"
                        aria-hidden="true"
                        data-id="Play"
                    >
                        <path
                            d="M28.1542369,14.3950429 L11.2393158,2.38145067 C10.6185599,1.94179981 9.79449964,1.87558733 9.11410778,2.21724372 C8.42829448,2.55625161 8,3.2448614 8,3.98908966 L8,28.0083286 C8,28.7605024 8.42829448,29.4464637 9.11410778,29.7854716 C9.4041553,29.9284905 9.72131007,30 10.0411756,30 C10.4586271,30 10.8815002,29.8702235 11.2393158,29.6133191 L28.1542369,17.6103209 C28.6882496,17.2262885 29,16.6330247 29,16.0026819 C29.0026936,15.3617451 28.6828281,14.7711298 28.1542369,14.3950429 Z"
                            fill="#ffffff"
                        ></path>
                    </svg>
                </div>
            </div>
        </div>
    );

    const video = (
        <iframe
            src="https://www.youtube.com/embed/Xui0rf5fBVg?modestbranding=1&rel=0&iv_load_policy=3&hl=es-sp&fs=0&color=white&controls=0&disablekb=1&autoplay=1"
            width="751"
            height="434"
            title={formatText('brokerAlternativeFunds-introVideo_videoTitle')}
            frameBorder="0"
            allow="autoplay;"
        ></iframe>
    );

    return (
        <div>
            <div className="broker-alternative-funds-view__section-title">
                <FormattedText value="brokerAlternativeFunds-introVideo_title" />
            </div>
            <div className="broker-alternative-funds-intro-video__video-container">{startedVideo ? video : notStartedState}</div>
        </div>
    );
};

export default BrokerAlternativeFundsIntroVideo;